import { apiClient } from '../../app/api';
import type {
  AdminAccountCredentials,
  CreateTenantRequest,
  ResetAdminPasswordRequest,
  TenantBootstrapView,
  TenantView,
  UpdateTenantRequest,
} from './types';

export function listTenants(): Promise<TenantView[]> {
  return apiClient.get<TenantView[]>('/operator/tenants');
}

export function createTenant(payload: CreateTenantRequest): Promise<TenantBootstrapView> {
  return apiClient.post<TenantBootstrapView>('/operator/tenants', payload);
}

export function updateTenant(id: number, payload: UpdateTenantRequest): Promise<TenantView> {
  return apiClient.patch<TenantView>(`/operator/tenants/${id}`, payload);
}

export function suspendTenant(id: number): Promise<void> {
  return apiClient.post<void>(`/operator/tenants/${id}/suspend`);
}

export function activateTenant(id: number): Promise<void> {
  return apiClient.post<void>(`/operator/tenants/${id}/activate`);
}

export function resetAdminPassword(
  id: number,
  payload: ResetAdminPasswordRequest,
): Promise<AdminAccountCredentials> {
  return apiClient.post<AdminAccountCredentials>(
    `/operator/tenants/${id}/reset-admin-password`,
    payload,
  );
}
